<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="80px">
        <el-form-item label="月份" prop="month">
          <el-date-picker v-model="queryParams.month"
                          type="month"
                          placeholder="选择月份"
                          value-format="yyyy-MM"
                          format="yyyy年MM月"
                          size="small"
                          style="width: 160px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          <el-button type="success"
                     icon="el-icon-download"
                     size="mini"
                     :disabled="summaryList.length === 0"
                     @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="gap"></div>

    <el-table v-loading="loading"
              :data="summaryList"
              border
              style="width: 100%">
                  <el-table-column label="序号" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="工号" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.phone || '-' }}
        </template>
      </el-table-column>
  
      <el-table-column label="姓名" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="部门" align="center" width="120">
        <template slot-scope="scope">
          {{ scope.row.department || '-' }}
        </template>
      </el-table-column>
      <el-table-column v-for="day in dayColumns"
                       :key="day"
                       :label="day"
                       align="center"
                       width="60">
        <template slot-scope="scope">
          {{ scope.row['day_' + day] }}
        </template>
      </el-table-column>
      <el-table-column label="汇总"
                       align="center"
                       width="80"
                       fixed="right">
        <template slot-scope="scope">
          <span style="font-weight: bold; color: #409EFF;">{{ scope.row.total }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="vips" v-if="userInfo.vips !== '1'">
      <span>完整功能仅对会员开放，非会员用户仅能查看10条报餐记录,请联系【管理员】升级会员</span>
    </div>
    <div v-if="!loading && summaryList.length === 0"
         class="empty-tip">暂无报餐数据</div>
  </div>
</template>

<script>
import { getOrderDetail } from '@/api/menuOrders/index'

export default {
  name: 'MenuOrders',
  data () {
    return {
      loading: false,
      summaryList: [],
      dayColumns: [],
      queryParams: {
        month: this.formatMonth(new Date())
      },
      userInfo: null
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    console.log(this.userInfo)
    this.computeDayColumns()
    this.handleQuery()
  },
  methods: {
    formatMonth (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    // 根据选中月份计算当月天数
    computeDayColumns () {
      const [year, month] = this.queryParams.month.split('-').map(Number)
      const daysInMonth = new Date(year, month, 0).getDate()
      const cols = []
      for (let i = 1; i <= daysInMonth; i++) {
        cols.push(String(i))
      }
      this.dayColumns = cols
    },
    // 计算单日报餐次数（早+中+晚），1表示报餐，0表示未报餐
    calcMealCount (item) {
      let count = 0
      if (item.breakfast === '1' || item.breakfast === 1) count++
      if (item.lunch === '1' || item.lunch === 1) count++
      if (item.dinner === '1' || item.dinner === 1) count++
      return count
    },
    handleQuery () {
      if (!this.queryParams.month) {
        this.$message.warning('请选择月份')
        return
      }
      this.computeDayColumns()
      this.getList()
    },
    getList () {
      let data = {
        companyCode: this.userInfo.companyCode || '',
        month: this.queryParams.month,
        vips:this.userInfo.vips || ''
      }
      this.loading = true
      getOrderDetail(data).then(res => {
        this.loading = false
        if (res.code == 200 || res.code == '200') {
          this.transformData(res.data)
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    // 将原始记录按用户分组，生成月报汇总
    transformData (apiData) {
      const list = apiData && apiData.list ? apiData.list : (Array.isArray(apiData) ? apiData : [])
      const userMap = {}
      list.forEach(item => {
        const user = item.userInfo || {}
        console.log(user)
        const openid = item.openid || user.openid || user.name || 'unknown'
        if (!userMap[openid]) {
          const row = {
            openid,
            name: user.name || '-',
            department: user.department || '-',
            phone: user.phone || '-',
            total: 0
          }
          this.dayColumns.forEach(d => {
            row['day_' + d] = 0
          })
          userMap[openid] = row
        }
        const mealDate = item.mealDate || ''
        const dayNum = Number(mealDate.split('-').pop())
        if (!isNaN(dayNum) && userMap[openid]['day_' + dayNum] !== undefined) {
          const cnt = this.calcMealCount(item)
          userMap[openid]['day_' + dayNum] += cnt
          userMap[openid].total += cnt
        }
      })
      this.summaryList = Object.values(userMap)
    },
    resetQuery () {
      this.queryParams.month = this.formatMonth(new Date())
      this.computeDayColumns()
      this.handleQuery()
    },
    // 导出月报汇总表为CSV
    handleExport () {
      if (this.summaryList.length === 0) {
        return this.$message.warning('暂无可导出的数据')
      }
      const headers = ['工号', '姓名', '部门', ...this.dayColumns, '汇总']
      const rows = this.summaryList.map(row => {
        const cells = [row.phone || '-', row.name || '-', row.department || '-']
        this.dayColumns.forEach(d => {
          cells.push(row['day_' + d] || 0)
        })
        cells.push(row.total)
        return cells
      })
      // 拼接CSV字符串，加BOM头防止中文乱码
      let csv = '\uFEFF' + headers.join(',') + '\n'
      rows.forEach(row => {
        csv += row.map(cell => {
          if (String(cell).indexOf(',') > -1) {
            return '"' + cell + '"'
          }
          return cell
        }).join(',') + '\n'
      })
      // 创建Blob并下载
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `报餐月报_${this.queryParams.month || '导出'}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.gap {
  margin: 20px 0;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.mb-4 {
  margin-bottom: 16px;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
.vips{
  color: red;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/menuOrders/menuOrders.vue